const hostname = window.location.hostname
const basePath = 'http://' + hostname + ':3030'

export default {
  api: {
    handling: {
      names: basePath + '/disaster-names',
      shelters: basePath + '/shelters',
      shelterStatuses: basePath + '/shelter-statuses',
      damages: basePath + '/damages'
    }
  }
}
